import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { CareerJourneys } from './pages/CareerJourneys';
import { Thoughts } from './pages/Thoughts';
import { TravelStories } from './pages/TravelStories';
import { SafeSpace } from './pages/SafeSpace';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Home data-id="element-3" />} data-id="element-2" />
        <Route path="/career-journeys" element={<CareerJourneys data-id="element-5" />} data-id="element-4" />
        <Route path="/thoughts" element={<Thoughts data-id="element-7" />} data-id="element-6" />
        <Route path="/travel-stories" element={<TravelStories data-id="element-9" />} data-id="element-8" />
        <Route path="/safe-space" element={<SafeSpace data-id="element-11" />} data-id="element-10" />
      </Routes>
    </Router>;
}